var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { styled } from '../styled';
import { Text } from '../text';
export var CodeComponentName = 'QuantumCode';
export var Root = styled(Text, { name: CodeComponentName, slot: 'Root' })(function (_a) {
    var theme = _a.theme;
    return ({
        display: 'inline',
        padding: theme.spacing(0.25, 0.75),
        color: theme.tokens.color_fg_default,
        backgroundColor: theme.tokens.color_bg_layer_alternate_bold,
        borderRadius: theme.shape.borderRadius,
    });
});
export var Code = React.forwardRef(function (props, ref) {
    var children = props.children, _a = props.variant, variant = _a === void 0 ? 'code2' : _a, textProps = __rest(props, ["children", "variant"]);
    return (React.createElement(Root, __assign({ ref: ref }, { component: 'span' }, { color: "textSecondary", variant: variant }, textProps), children));
});
